import fetch from 'isomorphic-fetch'
import { RSAA } from 'redux-api-middleware'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import { types } from './'

const PARTNER_API = getEnv(Env.PartnerServiceUrl)

export const getDashboardData = (payload: Cinch.DashboardFilterFormData) => {
  const qs = {
    startDate: new Date(payload.startDate).toISOString(),
    endDate: new Date(payload.endDate).toISOString(),
    customerNoList: payload.customerNoList || '',
  }

  return {
    [RSAA]: {
      endpoint: () => {
        const query = `startDate=${qs.startDate}&endDate=${qs.endDate}&customerNoList=${qs.customerNoList}`

        return `${PARTNER_API}/api/v1.0/summarystatistics?${query}`
      },
      method: 'GET',
      headers: (state: any) => ({
        Authorization: `Bearer ${state.oidc.user.access_token}`,
        'Content-Type': 'application/json',
      }),
      fetch,
      types: [
        {
          type: types.PARTNERS_DATA_LOAD_REQUEST,
          payload: qs,
        },
        {
          type: types.PARTNERS_DATA_LOAD_SUCCESS,
          payload: async (_action: any, _state: any, response: any) => {
            const res: Cinch.DealerSummaryResponse = await response.json()
            const metrics: any = res.metrics.reduce((acc, curr: Cinch.DealerMetricItem) => {
              return {
                ...acc,
                [curr.metricType]: curr.metricValue,
              }
            }, {})

            return {
              partnersSummaryData: {
                SearchAppearances: metrics.SearchAppearances,
                AdvertViews: metrics.AdvertViews,
                FavouritedVehicles: metrics.FavouritedVehicles,
              },
              partnersCustomerInteractionsData: {
                LocationViews: metrics.LocationViews,
                TelephoneCalls: metrics.TelephoneCalls,
                Emails: metrics.Emails,
                WebsiteReferrals: metrics.WebsiteReferrals,
                CallbackRequests: metrics.CallbackRequests,
              },
            }
          },
        },
        types.PARTNERS_DATA_LOAD_FAILURE,
      ],
    },
  }
}

export const getCustomers = () => {
  return {
    [RSAA]: {
      endpoint: `${PARTNER_API}/api/v1.0/customer`,
      method: 'GET',
      fetch,
      headers: (state: any) => ({
        Authorization: `Bearer ${state.oidc.user.access_token}`,
        'Content-Type': 'application/json',
      }),
      types: [
        types.PARTNERS_PROFILE_LOAD_REQUEST,
        types.PARTNERS_PROFILE_LOAD_SUCCESS,
        types.PARTNERS_PROFILE_LOAD_FAILURE,
      ],
    },
  }
}

export const resetDownloadEvents = () => ({ type: types.PARTNERS_DOWNLOAD_REPORT_EVENTS_RESET })

export const downloadEvents = () => ({
  [RSAA]: {
    endpoint: (state: any) => {
      const { startDate, endDate, customerNoList } = state.partners.dataQuery
      const query = `startDate=${startDate}&endDate=${endDate}&customerNoList=${customerNoList}`

      return `${PARTNER_API}/api/v1.0/report/event?${query}`
    },
    method: 'GET',
    fetch,
    headers: (state: any) => ({
      Authorization: `Bearer ${state.oidc.user.access_token}`,
      'Content-Type': 'application/json',
    }),
    types: [
      types.PARTNERS_DOWNLOAD_REPORT_EVENTS_REQUEST,
      types.PARTNERS_DOWNLOAD_REPORT_EVENTS_SUCCESS,
      types.PARTNERS_DOWNLOAD_REPORT_EVENTS_FAILURE,
    ],
  },
})
